import React from 'react';
import Inputs from '../../../Components/Inputs/Inputs';
import Icons from '../../../Components/Icons/Icons'; 
import InputConfig from "./InputConfig";

const LeftContent = (props) => {

	const {processLinesFields,valueChangeHandler,addLineHandler,windowFields,drillData,keywordValueToggle,
		updateKeywordValue,isKeywordEdit,keywordValueChangeHAndler,clearLineHandler} = props;
	const {keyword,keyword_value,status,keyword_value_back,id,pre_condition,conditional_keyword} = processLinesFields;

	let keywordJson = keyword_value.value;
	let keyworkFields = [];
	if(keywordJson && keywordJson !== '') {
		// keywordJson = JSON.parse(keywordJson);
		 Object.keys(keywordJson).map(function(key) {
            // console.log(key);
            keyworkFields.push(key);
        })
	}
	return (
		<div style={{"width": "50%"}}>
			<div className="filter_Box">
				<div className="filter_Header p-2">
					<div className="d-flex align-items-center justify-content-between">
						<label className="pl-3"> Automation Line Items </label>
						<a className="text-info textUnderline cursor-pointer pr-2" onClick={clearLineHandler}>
							<span className="pl-1" title="Fill the below and Add">Clear</span>
						</a>
						<a className="text-info textUnderline cursor-pointer pr-2" onClick={addLineHandler}>
							<Icons iconType="IconPlus" />
							<span className="pl-1" title="Fill the below and Add">{id && id!== '' ? 'Update Lines' : 'Add Lines'}  </span>
						</a>
					</div>
				</div>
				<div className="filter_Body">
					<div className="row" id="keywordName">
						<div className="col-10">
				        	<h6 className=" text-small">  Conditional Keywords </h6>
				            <div className="card">
				                <div className="card-body p-0">
				               		<Inputs fieldName={conditional_keyword.name} formData={JSON.stringify(conditional_keyword)} changed={e=>valueChangeHandler(e,conditional_keyword.name)} />
				               	</div>
				        	</div>
				    	</div>
						<div className="col-10">
				        	<h6 className=" text-small">  Pre Conditions </h6>
				            <div className="card">
				                <div className="card-body p-0">
				               		<Inputs fieldName={pre_condition.name} formData={JSON.stringify(pre_condition)} changed={e=>valueChangeHandler(e.target.value,pre_condition.name)} />
				               	</div>
				        	</div>
				    	</div>
						<div className="col-10">
				        	<h6 className=" text-small">  Keywords </h6>
				            <div className="card">
				                <div className="card-body p-0">
				               		<Inputs fieldName={keyword.name} formData={JSON.stringify(keyword)} changed={e=>valueChangeHandler(e,keyword.name)} />
				               	</div>
				        	</div>
				    	</div>
				    	<div className="col-2">
				    		<label> Is Active </label> 
			               	<Inputs fieldName={status.name} formData={JSON.stringify(status)} changed={e=>valueChangeHandler(e.target.checked,status.name)} />							                 	
				    	</div>
				    	<div className="col-12">
				    		<div className="d-flex align-items-center justify-content-between">
					    		<h6 className=" text-small">  Keyword Value </h6>
					    		{ isKeywordEdit === true ?
					    			<div>
							    		<a className="btn-border btn border-default mb-1" onClick={keywordValueToggle}> Cancel </a>
							    		<a className="btn primary_bg mb-1" onClick={keywordValueToggle} > Update </a>
							    	</div>
					    		: 
				    			<a className="pl-2 cursor-pointer  mb-1" onClick={keywordValueToggle}>
				        			<Icons iconType="Edit" />
				        		</a> }
				        	</div>
				            <div className="card">
				                <div className="card-body">
					               	{/*<Inputs fieldName={keyword_value.name} formData={JSON.stringify(keyword_value)} changed={e=>valueChangeHandler(e.target.value,keyword_value.name)} />*/}
					               	{ isKeywordEdit === true ?
					               		<div className="row">
					               		{ keyworkFields ?
					               			keyworkFields.map((item,ind) => {
					               				return (
					               					<div className="col-12 mb-2">
								            			<label> {item.toUpperCase()} </label>
								            			<input type="text" name={item} className="form-control-sm form-control" onChange={keywordValueChangeHAndler} value={keyword_value.value[item]}/>
								            		</div>
					               				)
					               			})
					               		: null }
					               		</div>
					               	: 
					               	<pre className="text-medium">
					               	{keyword_value.value ? JSON.stringify(keyword_value.value, undefined, 2) : ''}
					               	</pre> }							                 	
				            	</div>
				        	</div>
				    	</div>
				    	{ keyword.value !== '' ?
				    		<InputConfig
					    		{...props}
					    	/>
			    		: null }
					</div>	 														 
				</div>
			</div>
		</div>
	)
}

export default LeftContent;